var cell_default = {
  "cell": "aLz1U",
  "header": "zGfwg",
  "selected": "R6TlV",
  "editing": "r-SHG",
  "singleSelection": "IuCv-",
  "hideLastBlock": "lqNvT",
  "editorWrapper": "FdVXU",
  "viewerWrapper": "NL57n",
  "hideFirstBlock": "C-b-u",
  "editor": "_7gcXj",
  "edit": "_2lL-i",
  "view": "eJwjd",
  "editingToolbarWrapper": "_8PQDR",
  "selectAll": "NSzMg",
  "disableSelection": "QHXkx"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
